import firestore from "firedb/init"
import firebase from 'firebase/app'
const moment = require('moment');

function addAdminData(obj) {

    if (!obj.user) {
        obj.user = {
            email: firebase.auth().currentUser.email,
            uid: firebase.auth().currentUser.uid
        };
    }

    if (!obj.createDate) {
        obj.createDate = moment().format();
    }

    if (!obj.updateDate) {
        obj.updateDate = null;
    }

    return obj;
}

export default {

    create(collection, obj) {
        return firestore.collection(collection).add(addAdminData(obj));
    },

    getAll(collection) {

        return firestore.collection(collection).get()

            .then(snapshot => {
                let data = [];
                snapshot.forEach(doc => {
                    let obj = doc.data();
                    obj.id = doc.id;
                    data.push(obj);
                });

                return data;
            })
            .catch((e) => {
                if (e.code === 'permission-denied') {
                    throw {code: 404, message: 'Berechtigungen fehlen'};
                } else {
                    throw {code: 501, message: 'Unerwarteter Fehler'};
                }
            });
    }
}